import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Card,
    Space,
    Tag,
    Typography

} from "antd";

import {

    DollarCircleOutlined

} from "@ant-design/icons";

const { Title, Text } = Typography;

const PaymentNotificationCard = ({

                                     notification

                                 }) => {

    const { symbol } = useCurrency();

    return (

    <Card

        style={{

            marginBottom:15,

            borderRadius:12

        }}

    >

        <Space

            direction="vertical"

        >

            <Title level={5}>

                <DollarCircleOutlined />

                {" "}

                Paiement

            </Title>

            <Text>

                {notification.amount}

                {symbol(notification.currency)}

            </Text>

            <Tag color="green">

                {notification.status}

            </Tag>

        </Space>

    </Card>

    );
};

export default PaymentNotificationCard;